// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collaboration-logos[data-v-284a28d2]{display:flex;position:relative;justify-content:center;align-items:center}.collaboration-logos img[data-v-284a28d2]{display:block}@media(max-width: 767px){.collaboration-logos[data-v-284a28d2]{flex-flow:column}}.collaboration-x[data-v-284a28d2]{filter:invert(1)}.collaboration-partner-logo[data-v-284a28d2],.collaboration-me-logo[data-v-284a28d2]{max-width:300px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
